import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function loadCharges(requestBody) {
  return request({
    url: URL.act.charge.getEntityCharges,
    method: 'post',
    data: requestBody
  })
}

export function getTrustFromCharges(requestBody) {
  return request({
    url: URL.act.charge.getTrustFromCharges,
    method: 'post',
    data: requestBody
  })
}

export function insertChargeBatchByScheme(requestBody) {
  return request({
    url: URL.act.charge.insertChargeBatchByScheme,
    method: 'post',
    data: requestBody
  })
}

export function checkCharge(requestBody) {
  return request({
    url: URL.act.charge.checkChargeDirty,
    method: 'post',
    data: requestBody
  })
}

export function splitCharge(requestBody) {
  return request({
    url: URL.act.charge.splitCharge,
    method: 'post',
    data: requestBody
  })
}

// 根据jobUuid获取chargeList
export function getChargesByJobUuid(jobUuid) {
  return request({
    url: URL.act.charge.getChargeByJobUuid,
    method: 'get',
    params: { jobUuid }
  })
}

// 根据账单Uuid获取chargeList
export function getChargeByBillUuid(billingUuid) {
  return request({
    url: URL.act.charge.getChargeByBillUuid,
    method: 'get',
    params: { billingUuid }
  })
}
// 根据账单Uuid获取分成相关费用
export function getAgentSharedCharge(billingUuid) {
  return request({
    url: URL.act.charge.getAgentSharedCharge,
    method: 'get',
    params: { billingUuid }
  })
}

// 代收垫付以及费用页签以及对账页签  提交费用/取消提交
export function chargeSubmit(chargeKeys, chargeState, location) {
  return request({
    url: URL.act.charge.chargeSubmit,
    method: 'post',
    data: chargeKeys,
    params: { chargeState, location }
  })
}

// 发送更新sap费用消息
export function sendSapMessageByCharge(chargeKeys, oldSapStatus, sapStatus, needUpdateCharge) {
  return request({
    url: URL.act.charge.sendSapMessageByCharge,
    method: 'post',
    data: chargeKeys,
    params: { oldSapStatus, sapStatus, needUpdateCharge }
  })
}

export function sendHecMessageByCharge(chargeKeys, oldSapStatus, sapStatus, needUpdateCharge, isSend) {
  return request({
    url: URL.act.charge.sendHecMessageByCharge,
    method: 'post',
    data: chargeKeys,
    params: { oldSapStatus, sapStatus, needUpdateCharge, isSend }
  })
}

// 财务审核改单提交，修改sap状态
export function updateSapStatus(chargeKeys, sapState) {
  return request({
    url: URL.act.charge.updateSapStatus,
    method: 'post',
    data: chargeKeys,
    params: { sapState }
  })
}

// 获取销账记录
export function getClearHistory(chargeUuid) {
  return request({
    url: URL.act.charge.getClearHistory,
    method: 'get',
    params: { chargeUuid }
  })
}

// 费用审批
export function putAuditCharges(data) {
  return request({
    url: URL.act.charge.putAuditCharges,
    method: 'put',
    data
  })
}
// 费用驳回
export function rejectCharges(data, location) {
  return request({
    url: URL.act.charge.rejectCharges,
    method: 'put',
    data,
    params: { location }
  })
}

// 费用受控/取消受控
export function updateChargeControlled(chargeKeys, controlled, location) {
  return request({
    url: URL.act.charge.updateChargeControlled,
    method: 'post',
    data: chargeKeys,
    params: { controlled, location }
  })
}
// 费用受控/取消受控
export function getActualAmountNoBykeys(data) {
  return request({
    url: URL.act.charge.getActualAmountNoBykeys,
    method: 'post',
    data
  })
}
// 费用受控/取消受控
export function queryChargeByField(jobUuids) {
  return request({
    url: URL.act.charge.queryChargeByField,
    method: 'post',
    data: jobUuids
  })
}

// 邀请费用确认发送邮件
export function inviteToConfirmCharge(jobKey) {
  return request({
    url: URL.act.charge.inviteToConfirmCharge,
    method: 'get',
    params: { jobKey }
  })
}

// 更新charge
export function updateCharges(data) {
  return request({
    url: URL.act.charge.updateCharges,
    method: 'put',
    data
  })
}

// 发送sap消息
export function sendSapMessageByJob(data) {
  return request({
    url: URL.act.charge.sendSapMessageByJob,
    method: 'post',
    data
  })
}

// 合创交单
export function sendHecMessageByJob(data) {
  return request({
    url: URL.act.charge.sendHecMessageByJob,
    method: 'post',
    data
  })
}
// 合创撤回交单
export function backHecMessageByJob(data) {
  return request({
    url: URL.act.charge.backHecMessageByJob,
    method: 'post',
    data
  })
}

export function sendHecMessageByFinance(jobKeys, sapStatus) {
  return request({
    url: URL.act.charge.sendHecMessageByFinance,
    method: 'post',
    data: jobKeys,
    params: { sapStatus }
  })
}

// 获取创建付款申请所需的费用
export function getChargeForBillPayment(requestBody) {
  return request({
    url: URL.act.charge.getChargeForBillPayment,
    method: 'post',
    data: requestBody
  })
}

// 财务综合查询
export function financeChargeSearch(requestBody) {
  return request({
    url: URL.act.charge.financeChargeSearch,
    method: 'post',
    data: requestBody
  })
}

// 财务综合查询-打印
export function searchPrintCharge(requestBody) {
  return request({
    url: URL.act.charge.searchPrintCharge,
    method: 'post',
    data: requestBody
  })
}

// 费用列表
export function copyChargeSelector(data) {
  return request({
    url: URL.act.charge.copyChargeSelector,
    method: 'post',
    data
  })
}

// 查询外部文件导入日志记录
export function queryImportFileRecordLog(data) {
  return request({
    url: URL.act.charge.queryImportFileRecordLog,
    method: 'post',
    data
  })
}
// 仓库操作-新增仓库费，批量新增费用
export function batchInsertCharge(data) {
  return request({
    url: URL.act.charge.batchInsertCharge,
    method: 'post',
    data
  })
}

// 通过约号带入费用
export function generateChargeByContractNo(requestBody) {
  return request({
    url: URL.act.charge.generateChargeByContractNoUrl,
    method: 'post',
    data: requestBody
  })
}

// 费用名称是否被使用过
export function isRemoveChargeItem(chargeItemId) {
  return request({
    url: URL.act.charge.isRemoveChargeItem,
    method: 'get',
    params: { chargeItemId }
  })
}

// 财务审核模块-批量更新汇率按钮(列表)/更新汇率按钮(详情)-验证是否满足条件
export function validateForUpdateExchangeRate(data) {
  return request({
    url: URL.act.charge.validateForUpdateExchangeRate,
    method: 'post',
    data
  })
}

// 财务审核模块-批量更新汇率按钮(列表)/更新汇率按钮(详情)
export function updateExchangeRate(data) {
  return request({
    url: URL.act.charge.updateExchangeRate,
    method: 'post',
    data
  })
}

// 财务综合查询
export function exportEstimateTableFunc(requestBody) {
  return request({
    url: URL.act.charge.exportEstimateTableUrl,
    method: 'post',
    data: requestBody
  })
}

// 对账新版-对账-按费用模式-审核/取消审核
export function chargeAuditOrCancelAudit(chargeKeys, chargeState, location) {
  return request({
    url: URL.act.charge.chargeAuditOrCancelAudit,
    method: 'post',
    data: chargeKeys,
    params: { chargeState, location }
  })
}

// 更新汇率
export function updateChargeRatesByJob(params) {
  return request({
    url: URL.act.charge.updateChargeRatesByJob,
    method: 'get',
    params: params
  })
}

// 汇率更新(按ETD月份)
export function updateChargeRatesByEtdMonth(data) {
  return request({
    url: URL.act.charge.updateChargeRatesByEtdMonth,
    method: 'post',
    data
  })
}

// EAS同步费用
export function syncChargeToEas(data) {
  return request({
    url: URL.act.charge.syncChargeToEas,
    method: 'post',
    data
  })
}
// 对账新版-对账-批量修改批次
export function batchUpdateConfirmSerialNumber(chargeKeys, confirmSerialNumber = '') {
  return request({
    url: URL.act.charge.batchUpdateConfirmSerialNumber,
    method: 'post',
    data: chargeKeys,
    params: { confirmSerialNumber }
  })
}

// 查询分摊费用记录
export function querySharedCharge(requestBody) {
  return request({
    url: URL.act.charge.querySharedChargeUrl,
    method: 'post',
    data: requestBody
  })
}

// EAS同步-查询费用
export function searchEasCharge(requestBody) {
  return request({
    url: URL.act.charge.searchEasCharge,
    method: 'post',
    data: requestBody
  })
}

// EAS批量同步
export function batchSyncChargeToEas(requestBody) {
  return request({
    url: URL.act.charge.batchSyncChargeToEas,
    method: 'post',
    data: requestBody
  })
}

// 隆和EAS同步费用
export function syncChargeToLhEas(data) {
  return request({
    url: URL.act.charge.syncChargeToLhEas,
    method: 'post',
    data
  })
}
// 批量同步LTS
export function batchPushLtsFunc(data) {
  return request({
    url: URL.act.charge.batchPushLtsForJobAndCharge,
    method: 'post',
    data
  })
}
// 批量同步LTS-查询费用
export function queryLtsChargeFunc(data) {
  return request({
    url: URL.act.charge.queryLtsCharge,
    method: 'post',
    data: data
  })
}
// 数据推送结果查询
export function queryChargePushRecord(data) {
  return request({
    url: URL.act.charge.queryChargePushRecord,
    method: 'post',
    data
  })
}

// 数据推送结果--重新推送
export function reSendChargePushRecord(params) {
  return request({
    url: URL.act.charge.reSendChargePushRecord,
    method: 'get',
    params
  })
}

// 修改费用到期日
export function updateDueDate(chargeKeys, dueDate, dueDirtyDate) {
  return request({
    url: URL.act.charge.updateDueDate,
    method: 'post',
    data: chargeKeys,
    params: { dueDate, dueDirtyDate }
  })
}

// 上海虹迈同步暂估费用到用友
export function doHmSyncZgChargeToYongYou(chargeKeys) {
  return request({
    url: URL.act.charge.hmSyncZgChargeToYongYou,
    method: 'post',
    data: chargeKeys
  })
}

export function queryJobByChargeKeysFunc(data) {
  return request({
    url: URL.act.charge.queryJobByChargeKeysUrl,
    method: 'post',
    data
  })
}

// 修改费用备注
export function updateAppendRemark(data) {
  return request({
    url: URL.act.charge.updateAppendRemark,
    method: 'post',
    data: data
  })
}

/**
 * 校验费用是否发生变更
 * @param data
 * @returns {AxiosPromise}
 */
export function validateChargeHasUpdate(data) {
  return request({
    url: URL.act.charge.validateChargeHasUpdate,
    method: 'post',
    data: data
  })
}

// 对账差异处理
export function reconciliationDiffConfirm(data) {
  return request({
    url: URL.act.charge.reconciliationDiffConfirmUrl,
    method: 'post',
    data: data
  })
}
// 对账差异处理
export function saveChargesFunc(requestBody, location) {
  return request({
    url: URL.act.charge.saveChargesUrl,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

// 根据uuid查找费用
export function getChargeByUuid(uuid) {
  return request({
    url: URL.act.charge.getChargeByUuid,
    method: 'get',
    params: { uuid }
  })
}

// 对账新版-账单-账单编辑-组装账单费用信息
export function assemblyChargeOfBilling(data) {
  return request({
    url: URL.act.charge.assemblyChargeOfBilling,
    method: 'post',
    data: data
  })
}
